import './init-common-link-node-config';
import {
  setTextNodeGenerateFunc,
  setUnknownTextNodeConfig,
  setInvalidTextNodeConfig,
} from '@/business/chat/generate-text-node-config';
import UnknownTextNodeView from '@/component/message/text/component/unknown/index.vue';
import InvalidTextNode from '@/component/message/text/component/invalid/index.vue';
import NormalTextNodeView from '@/component/message/text/component/normal/index.vue';
import MentionMemberTextNodeView from '@/component/message/text/component/mention-member/index.vue';
import { TextNodeType } from '_c/typings/model/chat';
// import { logger } from '_c/util/logger';
import UrlTextNode from '@/component/message/text/component/url/index.vue';
import EmotionTextNode from '@/component/message/text/component/emotion/index.vue';
import CommonLinkTextNode from '@/component/message/text/component/common-link/index.vue';
import { extractCommonLinkTextNodeConfig } from '@/business/chat/generate-common-link-node-config';

// const TAG = 'initTextNodeConfig';

// function checkJSON(str: string): boolean {
//   let isValid = true;
//   try {
//     JSON.parse(str);
//   } catch (err) {
//     logger.error(TAG, 'JSON.parse fail, err: ', err);
//     isValid = false;
//   }
//   return isValid;
// }

/**
 * 设置未知文字块配置
 */
setUnknownTextNodeConfig({
  component: UnknownTextNodeView,
  isValid: true,
  isUnknown: true,
});

/**
 * 设置非法文字块配置
 */
setInvalidTextNodeConfig({
  component: InvalidTextNode,
  isValid: true,
  isUnknown: false,
});

/**
 * 设置@文字块配置生成方法
 */
setTextNodeGenerateFunc(TextNodeType.normal, () => ({
  component: NormalTextNodeView,
}));

/**
 * 设置@文字块配置生成方法
 */
setTextNodeGenerateFunc(TextNodeType.mentionMember, () => ({
  component: MentionMemberTextNodeView,
}));

/**
 * 设置@文字块配置生成方法
 */
setTextNodeGenerateFunc(TextNodeType.emotion, () => ({
  component: EmotionTextNode,
}));

/**
 * 设置url文字块
 */
setTextNodeGenerateFunc(TextNodeType.url, () => ({
  component: UrlTextNode,
}));

/**
 * 设置通用链接文字块
 */
setTextNodeGenerateFunc(TextNodeType.commonLink, (textNode) => {
  const commonLinkTextNodeConfig = extractCommonLinkTextNodeConfig(textNode);
  return {
    component: CommonLinkTextNode,
    props: {
      text: textNode.text,
      innerText: textNode.innerText,
      displayText: (commonLinkTextNodeConfig.props.displayName as string) ?? '',
      commonLinkTextNodeConfig,
    },
  };
});
